module.exports = __webpack_public_path__ + "img/w_sales.e255e1e8.png";